import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchAppCustomerStats } from "../../REDUX/actions/appCustomers";
import { formatEuro } from "./Projects/QuotePill";

/**
 * Headline cards above the customer list — same card row as
 * Prospects/ProspectStats/ProspectGeneralStats. Adapts to the active tab
 * (role = "Prospect" | "Client") and refetches whenever a CRUD succeeds
 * (statsVersion bump in the reducer).
 */
const AppCustomerStats = ({ role }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { stats, statsVersion } = useSelector(
    (state) => state.appCustomersReducer
  );
  const isProspect = role === "Prospect";
  const currentYear = new Date().getFullYear();

  const abortRef = useRef(null);
  useEffect(() => {
    abortRef.current?.abort();
    abortRef.current = new AbortController();
    dispatch(fetchAppCustomerStats(role, abortRef.current.signal));
    return () => abortRef.current?.abort();
  }, [dispatch, role, statsVersion]);

  const cards = isProspect
    ? [
        { label: "Total prospects", value: stats?.total, bgColor: "#577b87" },
        {
          label: "Prospects",
          value: stats?.currentYear,
          bgColor: "#8fa9b8",
          showYear: true,
        },
        {
          label: "Prospects with project",
          value: stats?.withProjectCurrentYear,
          bgColor: "#345d68",
          showYear: true,
        },
      ]
    : [
        { label: "Total clients", value: stats?.total, bgColor: "#577b87" },
        // Clients who have used the app (customers/stats appAccounts).
        {
          label: "Clients with the app",
          value: stats?.appAccounts,
          bgColor: "#8fa9b8",
        },
        {
          label: "Client revenue excl. VAT",
          value:
            stats?.revenueHT !== undefined
              ? formatEuro(stats.revenueHT)
              : undefined,
          bgColor: "#345d68",
        },
      ];

  return (
    <div className="row flex-nowrap g-3 pt-2 pb-2 overflow-auto">
      {cards.map(({ label, value, bgColor, showYear }) => (
        <div className="col-4" key={label}>
          <div
            className="p-3 px-4 br20 flex-1 flex-column h-100"
            style={{ backgroundColor: bgColor }}
          >
            <span className="d-block text-white sBold f20 mb-1">
              {t(`${label}`)} {showYear ? currentYear : ""}
            </span>
            <span className="d-block text-white text-nowrap bold f33">
              {value ?? 0}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppCustomerStats;
